import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ResultsReport.css";
import { classSubjects } from "./subjects.jsx";

const ResultReport = ({ selectedClass, selectedSection, selectedTest, onBack, classTeacherFor, subjectTeacherFor }) => {
  const [marks, setMarks] = useState({});
  const [maxMarks, setMaxMarks] = useState({});
  const [remarks, setRemarks] = useState({});
  const [traitRemarks, setTraitRemarks] = useState({});
  const [coMarks, setCoMarks] = useState({});
  const [students, setStudents] = useState([]);
  const [currentStudentIndex, setCurrentStudentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [coMarksLoading, setCoMarksLoading] = useState(false);
  const [coMarksError, setCoMarksError] = useState(null);
  const [traitRemarksLoading, setTraitRemarksLoading] = useState(false);
  const [traitRemarksError, setTraitRemarksError] = useState(null);
  const [userRole, setUserRole] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedStream, setSelectedStream] = useState("science");

  const classData = classSubjects[selectedClass] || classSubjects["1"];
  const { scholastic, coScholastic: coSubjects = [], traitObservations = [], template } = classData;

  const isPrepClass = ["prep 1", "prep 2", "prep 3", "prep i", "prep ii", "prep iii"].includes(
    selectedClass?.toLowerCase().trim()
  );
  
   const getTestDisplayName = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const nextYear = currentYear + 1;
    const testYear = `${currentYear}–${String(nextYear).slice(-2)}`;
    if (isPrepClass) {
      switch (selectedTest) {
        case "I Unit Test":
          return `I Unit Assessment (${testYear})`;
        case "II Unit Test":
          return `II Unit Assessment (${testYear})`;
        case "I Term Examination":
          return `I Term Assessment (${testYear})`;
        case "Annual Examination":
          return `Annual Assessment (${testYear})`;
        default:
          return `${selectedTest} (${testYear})`;
      }
    } else {
      return `${selectedTest} (${testYear})`;
    }
  };

  const getFilteredSubjects = () => {
    if (!scholastic) {
      return [];
    }

    const isUnitTest = selectedTest?.toLowerCase().includes("unit test");

    if (["9", "10"].includes(selectedClass)) {
      const streamKey = selectedStream?.toLowerCase()?.trim();
      const commonSubjects = scholastic.common || [];
      const streamSubjects = scholastic[streamKey] || [];

      const adjustedCommonSubjects = commonSubjects.map((subject) => ({
        ...subject,
        maxMarks: isUnitTest ? subject.maxMarks.unitTest : subject.maxMarks.termExam,
      }));
      const adjustedStreamSubjects = streamSubjects.map((subject) => ({
        ...subject,
        maxMarks: isUnitTest ? subject.maxMarks.unitTest : subject.maxMarks.termExam,
      }));

      return [...adjustedCommonSubjects, ...adjustedStreamSubjects].filter(
        (subject) => subject && subject.id && subject.name && subject.maxMarks !== undefined
      );
    }

    return Array.isArray(scholastic)
      ? scholastic.map((subject) => ({
          ...subject,
          maxMarks: isUnitTest ? subject.maxMarks.unitTest : subject.maxMarks.termExam,
        })).filter((subject) => subject && subject.id && subject.name && subject.maxMarks !== undefined)
      : [];
  };

  const subjects = getFilteredSubjects();

  console.log("ResultReport Props - Class:", selectedClass, "Section:", selectedSection, "Stream:", selectedStream, "Test:", selectedTest);
  console.log("ResultReport - subjectTeacherFor:", subjectTeacherFor);
  console.log("ResultReport - assignedSubjects:", subjectTeacherFor[`${selectedClass} - ${selectedSection}`] || []);
  console.log("ResultReport - Scholastic Subjects:", subjects.map(s => ({ id: s.id, name: s.name, maxMarks: s.maxMarks })));

  const API_URL = "https://aadyaacademy.org/api";

  const isClassTeacher = classTeacherFor.some(
    (entry) =>
      entry.class?.trim().toLowerCase() === selectedClass?.trim().toLowerCase() &&
      entry.section?.trim().toLowerCase() === selectedSection?.trim().toLowerCase()
  );

  const isSubjectTeacher = subjectTeacherFor.some(
    (entry) =>
      entry.class?.trim().toLowerCase() === selectedClass?.trim().toLowerCase() &&
      entry.section?.trim().toLowerCase() === selectedSection?.trim().toLowerCase()
  );

  const subjectMap = {
    eng_lang_comprehension: "English Language",
    eng_lang_written: "English Language",
    eng_lit_reading: "English Literature",
    eng_lit_written: "English Literature",
    kannada_reading: "Kannada",
    kannada_written: "Kannada",
    hindi_reading: "Hindi",
    hindi_written: "Hindi",
    math_project: "Mathematics",
    math_written: "Mathematics",
    evs_project: "EVS",
    evs_written: "EVS",
    comp_theory: "Computer Studies",
    comp_practical: "Computer Studies",
    comp_robotics: "Computer Studies",
    co_general_knowledge: "General Knowledge",
    co_value_education: "Value Education",
    co_communication: "Communication",
    co_drawing_craft: "Drawing & Craft",
    co_abacus: "Abacus",
    trait_punctuality: "Punctuality",
    trait_enthusiasm: "Enthusiasm & Confidence",
    trait_class_participation: "Participation - Classroom",
    trait_activity: "Participation - Activity",
    trait_eca: "ECA",
    trait_cca: "CCA",
    trait_neatness: "Neatness",
    trait_assignment: "Assignment",
    eng_paper1: "English Paper I",
    eng_paper2: "English Paper II",
    ii_language: "II Language",
    hcg_paper1: "H.C.G Paper I",
    hcg_paper2: "H.C.G Paper II",
    math: "Mathematics",
    physics: "Physics",
    chemistry: "Chemistry",
    biology: "Biology",
    computer_app: "Computer Application",
    commercial_studies: "Commercial Studies",
    economics: "Economics",
  };

  const canEdit = (subjectId = null) => {
    return true; // Allow unlimited edits for all users
  };

  const fetchMarks = async (retryCount = 0) => {
    const currentStudent = students[currentStudentIndex];
    if (!currentStudent?.student_id) {
      console.warn("No valid student_id found for fetching marks");
      return;
    }
    if (!selectedTest) {
      console.warn("No test selected for fetching marks");
      toast.error("Please select a test.");
      return;
    }

    setCoMarksLoading(true);
    setTraitRemarksLoading(true);
    setCoMarksError(null);
    setTraitRemarksError(null);

    try {
      const response = await axios.get(`${API_URL}/student_marks`, {
        params: {
          student_id: currentStudent.student_id,
          test_name: selectedTest,
          stream: ["9", "10"].includes(selectedClass) ? selectedStream : undefined,
        },
        headers: { "X-User-Role": userRole || "teacher", "Content-Type": "application/json", "Cache-Control": "no-store" },
      });

      const marksData = response.data || {};
      console.log(`[Class ${selectedClass} - ${selectedStream} - Test ${selectedTest}] Fetched Marks Data for ${currentStudent.student_id}:`, JSON.stringify(marksData, null, 2));

      const newMarks = {};
      const newMaxMarks = {};
      const newCoMarks = {};
      const newTraitRemarks = {};
      const newRemarks = {};

      // Initialize maxMarks for all subjects
      subjects.forEach((subject) => {
        newMaxMarks[`${currentStudent.student_id}-${subject.id}`] = subject.maxMarks;
      });

      Object.entries(marksData.scholastic_marks || {}).forEach(([subjectSpec, value]) => {
        let normalizedSubjectSpec = subjectSpec.replace(new RegExp(`^${currentStudent.student_id}-`), "").replace("-obtained", "");
        const matchedSubject = subjects.find((s) => s.id?.trim().toLowerCase() === normalizedSubjectSpec?.trim().toLowerCase());
        if (matchedSubject) {
          newMarks[`${currentStudent.student_id}-${matchedSubject.id}-obtained`] = value || "";
          newMaxMarks[`${currentStudent.student_id}-${matchedSubject.id}`] = matchedSubject.maxMarks;
        } else {
          toast.warn(`Unrecognized subject ${normalizedSubjectSpec} for ${currentStudent.student_id}`);
        }
      });

      Object.entries(marksData.co_scholastic_marks || {}).forEach(([coSubjectName, value]) => {
        let normalizedCoSubjectName = coSubjectName.replace(new RegExp(`^${currentStudent.student_id}-`), "").replace("-obtained", "");
        const coSubject = coSubjects.find((s) => s.id?.trim().toLowerCase() === normalizedCoSubjectName?.trim().toLowerCase());
        if (coSubject) {
          newCoMarks[`${currentStudent.student_id}-${coSubject.id}-obtained`] = value ? value.toUpperCase() : "";
          console.log(`[Class ${selectedClass} - ${selectedStream}] Set co-scholastic ${coSubject.id} for ${currentStudent.student_id}: ${value}`);
        } else {
          console.warn(`Co-scholastic subject ${normalizedCoSubjectName} not found in class ${selectedClass}`);
        }
      });

      Object.entries(marksData.traitRemarks || {}).forEach(([traitId, value]) => {
        let normalizedTraitId = traitId.replace(new RegExp(`^${currentStudent.student_id}-`), "");
        const trait = traitObservations.find((t) => t.id?.trim().toLowerCase() === normalizedTraitId?.trim().toLowerCase());
        if (trait) {
          newTraitRemarks[`${currentStudent.student_id}-${trait.id}`] = value ? value.toUpperCase() : "";
          console.log(`[Class ${selectedClass} - ${selectedStream}] Set trait ${trait.id} for ${currentStudent.student_id}: ${value}`);
        } else {
          console.warn(`Trait ${normalizedTraitId} not found in class ${selectedClass}`);
        }
      });

      newRemarks[currentStudent.student_id] = marksData.remarks || "";
      console.log(`[Class ${selectedClass} - ${selectedStream}] Set remarks for ${currentStudent.student_id}:`, marksData.remarks);

      setMarks(newMarks);
      setMaxMarks(newMaxMarks);
      setCoMarks(newCoMarks);
      setTraitRemarks(newTraitRemarks);
      setRemarks(newRemarks);
      setCoMarksLoading(false);
      setTraitRemarksLoading(false);
    } catch (error) {
      console.error(`[Class ${selectedClass} - ${selectedStream}] Failed to fetch marks:`, error);
      if (retryCount < 2) {
        console.log(`Retrying fetchMarks (attempt ${retryCount + 1})...`);
        setTimeout(() => fetchMarks(retryCount + 1), 1000);
      } else {
        setCoMarksError(`Failed to fetch co-scholastic marks. Contact the administrator.`);
        setTraitRemarksError(`Failed to fetch trait remarks. Contact the administrator.`);
        toast.error(error.response?.data?.message || `Failed to fetch marks. Contact the administrator.`);
        setCoMarksLoading(false);
        setTraitRemarksLoading(false);
      }
    }
  };

  useEffect(() => {
    const fetchUserRole = async () => {
      let role = localStorage.getItem("userRole") || "teacher";
      setUserRole(role);
    };

    fetchUserRole();
  }, []);

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        setLoading(true);
        if (!selectedClass || !selectedSection || !selectedTest) {
          toast.warning("Please select class, section, and test");
          setStudents([]);
          return;
        }

        const response = await axios.get(`${API_URL}/students`, {
          params: {
            className: selectedClass,
            section: selectedSection,
            stream: ["9", "10"].includes(selectedClass) ? selectedStream : undefined,
            test_name: selectedTest,
          },
          headers: { "X-User-Role": userRole || "teacher", "Content-Type": "application/json", "Cache-Control": "no-store" },
        });

        let studentData = Array.isArray(response.data.data) ? response.data.data : response.data;
        const filtered = studentData.filter(
          (student) =>
            student.class?.trim().toLowerCase() === selectedClass?.trim().toLowerCase() &&
            student.section?.toUpperCase().trim() === selectedSection?.toUpperCase().trim() &&
            (selectedClass !== "9" || !student.stream || student.stream?.toLowerCase() === selectedStream)
        );

        if (filtered.some((student) => !student.student_id)) {
          toast.error("Some students have invalid IDs. Contact the administrator.");
        }

        const sortedStudents = filtered.sort((a, b) =>
          (a.student_name || "").toLowerCase().localeCompare((b.student_name || "").toLowerCase())
        );

        setStudents(sortedStudents);
        setCurrentStudentIndex(0);
      } catch (error) {
        toast.error(error.response?.data?.message || `Failed to load students. Contact the administrator.`);
        setStudents([]);
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, [selectedClass, selectedSection, selectedTest, userRole, selectedStream]);

  useEffect(() => {
    if (students.length > 0 && ["teacher", "admin"].includes(userRole) && selectedTest) {
      fetchMarks();
    } else {
      setMarks({});
      setMaxMarks({});
      setCoMarks({});
      setTraitRemarks({});
      setRemarks({});
      setCoMarksLoading(false);
      setTraitRemarksLoading(false);
      setCoMarksError(null);
      setTraitRemarksError(null);
    }
  }, [currentStudentIndex, students, userRole, selectedStream, selectedTest]);

  const handleMarksChange = (studentId, subjectId, value) => {
    const normalizedSubjectId = subjectId.split("-obtained")[0];
    const subject = subjects.find((s) => s.id === normalizedSubjectId);
    if (!subject) {
      toast.error("Invalid subject selected.");
      return;
    }

    const validGrades = ["A+", "A", "B+", "B", "C", "AB"];
    const normalizedValue = value ? value.toUpperCase() : "";
    const maxMarksValue = subject.maxMarks;

    if (isPrepClass) {
      if (validGrades.includes(normalizedValue) || value === "") {
        setMarks((prev) => ({
          ...prev,
          [`${studentId}-${subject.id}-obtained`]: value === "" ? "" : normalizedValue,
        }));
        console.log(`[Class ${selectedClass} - ${selectedStream}] Updated scholastic marks[${studentId}-${subject.id}-obtained]: ${value === "" ? "empty" : normalizedValue}`);
      } else {
        toast.error(`Invalid grade. Use A+, A, B+, B, C, or AB.`);
      }
    } else {
      const numValue = parseFloat(value);
      if (value === "" || (!isNaN(numValue) && numValue >= 0 && numValue <= maxMarksValue)) {
        setMarks((prev) => ({
          ...prev,
          [`${studentId}-${subject.id}-obtained`]: value,
        }));
        console.log(`[Class ${selectedClass} - ${selectedStream}] Updated scholastic marks[${studentId}-${subject.id}-obtained]: ${value === "" ? "empty" : value}`);
      } else {
        toast.error(`Marks must be between 0 and ${maxMarksValue}.`);
      }
    }
  };

  const handleCoMarksChange = (studentId, coSubjectId, value) => {
    const normalizedCoSubjectId = coSubjectId.split("-obtained")[0];
    const key = `${studentId}-${normalizedCoSubjectId}-obtained`;
    const validGrades = ["A+", "A", "B+", "B", "C", "AB", ""];
    const normalizedValue = value ? value.toUpperCase() : "";

    console.log(`[Class ${selectedClass} - ${selectedStream}] Attempting to set co-scholastic ${key}: ${value} (normalized: ${normalizedValue})`);

    if (validGrades.includes(normalizedValue)) {
      setCoMarks((prev) => ({
        ...prev,
        [key]: normalizedValue,
      }));
      console.log(`[Class ${selectedClass} - ${selectedStream}] Updated coMarks[${key}]: ${normalizedValue}`);
    } else {
      toast.error(`Invalid grade for class ${selectedClass}. Use A+, A, B+, B, C, AB, or leave empty.`);
      console.log(`[Class ${selectedClass} - ${selectedStream}] Invalid co-scholastic grade: ${value}`);
    }
  };

  const handleTraitRemarksChange = (studentId, traitId, value) => {
    const validGrades = ["A+", "A", "B+", "B", "AB", "", "C", "D"];
    const normalizedValue = value ? value.toUpperCase() : "";
    if (!isPrepClass && value && !validGrades.includes(normalizedValue)) {
      toast.error(`Invalid trait grade. Use A+, A, B+, B, AB, or leave empty.`);
      return;
    }
    setTraitRemarks((prev) => ({
      ...prev,
      [`${studentId}-${traitId}`]: normalizedValue,
    }));
    console.log(`[Class ${selectedClass} - ${selectedStream}] Updated traitRemarks[${studentId}-${traitId}]: ${normalizedValue}`);
  };

  const handleRemarksChange = (studentId, value) => {
    setRemarks((prev) => ({
      ...prev,
      [studentId]: value,
    }));
    console.log(`[Class ${selectedClass} - ${selectedStream}] Updated remarks[${studentId}]: ${value}`);
  };

  const handleStreamChange = (e) => {
    setSelectedStream(e.target.value);
    setMarks({});
    setMaxMarks({});
    setCurrentStudentIndex(0);
  };

  const handleSubmit = async () => {
  if (isSubmitting) {
    toast.warn("Submission in progress, please wait");
    return;
  }

  if (!selectedTest) {
    toast.error("Please select a test before submitting.");
    return;
  }

  const currentStudent = students[currentStudentIndex];
  if (!currentStudent?.student_id) {
    toast.error("No valid student selected.");
    return;
  }

  const teacherPhone = localStorage.getItem("userPhone");
  if (!teacherPhone && userRole !== "admin") {
    toast.error("Teacher phone number not found. Please log in again.");
    return;
  }

  setIsSubmitting(true);

  try {
    const payload = {
      student_id: currentStudent.student_id,
      class_name: selectedClass,
      test_name: selectedTest,

      teacher_phone: userRole === "admin" ? undefined : teacherPhone,

      scholastic_marks: Object.fromEntries(
        subjects.map(s => [
          s.id,
          marks[`${currentStudent.student_id}-${s.id}-obtained`] || ""
        ])
      ),

      co_scholastic_marks: Object.fromEntries(
        coSubjects.map(cs => [
          cs.id,
          coMarks[`${currentStudent.student_id}-${cs.id}-obtained`] || ""
        ])
      ),

      max_marks: Object.fromEntries(
        subjects.map(s => [s.id, s.maxMarks])
      ),

      traitRemarks: Object.fromEntries(
        traitObservations.map(t => [
          t.id,
          traitRemarks[`${currentStudent.student_id}-${t.id}`] || ""
        ])
      ),

      remarks: remarks[currentStudent.student_id] || "",

      // 🔥 KEY FIX IS HERE
      is_submitted: userRole === "admin",

      ...(["9", "10"].includes(selectedClass)
        ? { stream: selectedStream }
        : {})
    };

    const endpoint =
      userRole === "admin"
        ? "/admin/update_marks"
        : "/student_marks";

    const response = await axios.post(
      `${API_URL}${endpoint}`,
      payload,
      {
        headers: {
          "X-User-Role": userRole || "teacher",
          "Content-Type": "application/json",
          "Cache-Control": "no-store",
        },
      }
    );

    toast.success(
      userRole === "admin"
        ? "Marks published successfully"
        : "Marks saved (Waiting for admin approval)"
    );

    await fetchMarks();

  } catch (err) {
    console.error("Submit Error:", err);
    toast.error(
      err.response?.data?.message ||
      "Failed to update marks. Contact administrator."
    );
  } finally {
    setIsSubmitting(false);
  }
};

  const calculateTotals = (studentId) => {
    let totalMax = 0;
    let totalScored = 0;
    const isUnitTest = selectedTest?.toLowerCase().includes("unit test");

    subjects.forEach((subject) => {
      const key = `${studentId}-${subject.id}-obtained`;
      const max = maxMarks[`${studentId}-${subject.id}`] || subject.maxMarks;
      const value = marks[key] || "";

      let scored = 0;
      if (isPrepClass) {
        scored =
          value === "A+" ? max * 0.90 :
          value === "A" ? max * 0.80 :
          value === "B+" ? max * 0.70 :
          value === "B" ? max * 0.60 :
          value === "C" ? max * 0.50 :
          value === "AB" ? 0 : 0;
      } else {
        scored = value === "" ? 0 : parseFloat(value) || 0;
      }

      totalMax += max;
      totalScored += scored;
    });

    const percentage = totalMax > 0 ? (totalScored / totalMax) * 100 : 0;

    return {
      totalMax,
      totalScored,
      percentage,
      grade:
        percentage >= 94 ? "A+" :
        percentage >= 84 ? "A" :
        percentage >= 69 ? "B+" :
        percentage >= 49 ? "B" :
        percentage >= 39 ? "C" : "D",
    };
  };

  const downloadAllPDFs = async () => {
    toast.error("PDF generation is not available.");
  };

  return (
    <div className="result-report">
      <ToastContainer />
      {loading ? (
        <p>Loading...</p>
      ) : students.length > 0 && ["teacher", "admin"].includes(userRole) ? (
        <div className="student-report">
          <h2>{getTestDisplayName()}</h2>
          <div className="top-header-row">
            <button onClick={onBack} className="back-button">
              ← Back
            </button>
            {(selectedClass === "9" || selectedClass === "10") && (
              <div className="stream-selector" style={{ marginLeft: "20px" }}>
                <label htmlFor="stream-select">Stream: </label>
                <select
                  id="stream-select"
                  value={selectedStream}
                  onChange={handleStreamChange}
                  style={{ padding: "5px", fontSize: "14px" }}
                >
                  <option value="science">Science</option>
                  <option value="commerce">Commerce</option>
                </select>
              </div>
            )}
            <div className="navigation-arrows top-nav">
              <button
                onClick={() => setCurrentStudentIndex((i) => Math.max(i - 1, 0))}
                disabled={currentStudentIndex === 0}
              >
                ←
              </button>
              <span>
                {currentStudentIndex + 1} of {students.length}
              </span>
              <button
                onClick={() => setCurrentStudentIndex((i) => Math.min(i + 1, students.length - 1))}
                disabled={currentStudentIndex === students.length - 1}
              >
                →
              </button>
            </div>
          </div>
          <div className="student-header">
            <div className="student-info">
              <h3>Name: {students[currentStudentIndex]?.student_name || "N/A"}</h3>
              <h3>Student ID: {students[currentStudentIndex]?.student_id || "N/A"}</h3>
              <h3>
                Class: {(students[currentStudentIndex]?.class || "N/A") + " - " + (students[currentStudentIndex]?.section || "N/A")}
                {selectedClass === "9" || selectedClass === "10" ? ` (${selectedStream.charAt(0).toUpperCase() + selectedStream.slice(1)})` : ""}
              </h3>
            </div>
          </div>

          <div className="scholastic-section">
            {template.renderScholastic(
              subjects,
              marks,
              handleMarksChange,
              students[currentStudentIndex],
              !canEdit(),
              selectedTest?.toLowerCase().includes("unit test")
            )}
          </div>

          <div
            className="co-traits-container"
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "20px",
              alignItems: "flex-start",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <div className="traits-section" style={{ flex: 1, minWidth: 0 }}>
              {traitRemarksLoading ? (
                <p>Loading trait remarks...</p>
              ) : traitRemarksError ? (
                <p style={{ color: "red", fontWeight: "bold" }}>{traitRemarksError}</p>
              ) : (
                template.renderTraits(
                  traitObservations,
                  traitRemarks,
                  handleTraitRemarksChange,
                  students[currentStudentIndex],
                  !canEdit()
                )
              )}
            </div>

            {coSubjects.length > 0 && (
              <div className="co-scholastic-section" style={{ flex: 1, minWidth: 0 }}>
                {coMarksLoading ? (
                  <p>Loading co-scholastic marks...</p>
                ) : coMarksError ? (
                  <p style={{ color: "red", fontWeight: "bold" }}>{coMarksError}</p>
                ) : (
                  template.renderCoScholastic(
                    coSubjects,
                    coMarks,
                    handleCoMarksChange,
                    students[currentStudentIndex],
                    !canEdit()
                  )
                )}
              </div>
            )}
          </div>

          {!isPrepClass && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                marginTop: "15px",
                marginBottom: "15px",
                fontFamily: "Arial, sans-serif",
              }}
            >
              <div
                style={{
                  border: "1px solid #000",
                  borderRadius: "5px",
                  padding: "6px 8px",
                  textAlign: "center",
                  width: "18%",
                }}
              >
                <div style={{ fontWeight: "bold", fontSize: "12px" }}>Grand Total</div>
                <div style={{ marginTop: "2px", fontSize: "13px" }}>
                  {calculateTotals(students[currentStudentIndex]?.student_id).totalScored} / {calculateTotals(students[currentStudentIndex]?.student_id).totalMax}
                </div>
              </div>
              <div
                style={{
                  border: "1px solid #000",
                  borderRadius: "5px",
                  padding: "6px 8px",
                  textAlign: "center",
                  width: "18%",
                }}
              >
                <div style={{ fontWeight: "bold", fontSize: "12px" }}>Percentage</div>
                <div style={{ marginTop: "2px", fontSize: "13px" }}>
                  {calculateTotals(students[currentStudentIndex]?.student_id).percentage.toFixed(2)}%
                </div>
              </div>
              <div
                style={{
                  border: "1px solid #000",
                  borderRadius: "5px",
                  padding: "6px 8px",
                  textAlign: "center",
                  width: "18%",
                }}
              >
                <div style={{ fontWeight: "bold", fontSize: "12px" }}>Grade</div>
                <div style={{ marginTop: "2px", fontSize: "13px" }}>
                  {calculateTotals(students[currentStudentIndex]?.student_id).grade}
                </div>
              </div>
            </div>
          )}

          <div className="remarks-section">
            <h4>Remarks</h4>
            <textarea
              id="remarks"
              value={remarks[students[currentStudentIndex]?.student_id] || ""}
              onChange={(e) => handleRemarksChange(students[currentStudentIndex]?.student_id, e.target.value)}
              disabled={!canEdit()}
              readOnly={!canEdit()}
              style={{ backgroundColor: !canEdit() ? "#f0f0f0" : "white" }}
              placeholder="Enter remarks here"
            />
          </div>

          <div className="navigation-submit-row">
            <button
              className="submit-button"
              onClick={handleSubmit}
              disabled={isSubmitting || !canEdit()}
            >
              {isSubmitting ? "Submitting..." : "Save"}
            </button>
            <button
              className="submit-button"
              style={{ backgroundColor: "#00aa66", color: "white" }}
              onClick={downloadAllPDFs}
            >
              <FontAwesomeIcon icon={faDownload} /> Download All PDFs
            </button>
            <div className="navigation-arrows">
              <button
                onClick={() => setCurrentStudentIndex((i) => Math.max(i - 1, 0))}
                disabled={currentStudentIndex === 0}
              >
                ←
              </button>
              <span>
                {currentStudentIndex + 1} of {students.length}
              </span>
              <button
                onClick={() => setCurrentStudentIndex((i) => Math.min(i + 1, students.length - 1))}
                disabled={currentStudentIndex === students.length - 1}
              >
                →
              </button>
            </div>
          </div>
        </div>
      ) : (
        <p>No students found or access denied</p>
      )}
    </div>
  );
};

export default ResultReport;